/**
 * Therapy Styles API Service
 *
 * API client functions for fetching available therapy styles.
 * Used for settings page and reflection style selection.
 */

import { apiClient } from "./api";
import type {
  TherapyStyleResponse,
  TherapyStyleDetailResponse,
} from "@/types/therapy-style";

const API_PREFIX = import.meta.env.VITE_API_V1_PREFIX || "/api/v1";

/**
 * List all active therapy styles
 *
 * Returns styles sorted by display_order for consistent UI presentation.
 */
export async function listTherapyStyles(): Promise<TherapyStyleResponse[]> {
  const response = await apiClient.get<TherapyStyleResponse[]>(
    `${API_PREFIX}/therapy-styles`
  );
  return response.data;
}

/**
 * Get a specific therapy style by ID
 *
 * Returns detailed information including the system prompt.
 */
export async function getTherapyStyle(
  id: string
): Promise<TherapyStyleDetailResponse> {
  const response = await apiClient.get<TherapyStyleDetailResponse>(
    `${API_PREFIX}/therapy-styles/${id}`
  );
  return response.data;
}
